import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminRedirects = lazy(() => import("@/pages/admin/AdminRedirects"));

export const Route = createFileRoute("/admin/omdirigeringar")({
  component: () => <AdminRedirects />,
});
